var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-nav",
    {
      staticClass:
        "navbar-top navbar-expand navbar-dark bg-navy px-3 -sticky-top test",
      attrs: { "container-classes": "container-fluid", type: "" },
    },
    [
      _c(
        "portal",
        { attrs: { to: "sidebar" } },
        [
          _c(
            "sidebar-right",
            {
              class: [
                "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400",
                { open: _vm.showSearchModal },
              ],
              on: {
                overlayClicked: function ($event) {
                  _vm.showSearchModal = false
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "bg-white md__card--holder clearfix search-project yellow-class",
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-header d-flex align-items-center" },
                    [
                      _c("span", { staticClass: "header-title" }, [
                        _vm._v("Search\n            "),
                        _c("span", { staticClass: "bracket" }, [_vm._v(" { ")]),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "form",
                      { attrs: { role: "form" } },
                      [
                        _c("base-input", {
                          staticClass: "mb-3",
                          attrs: {
                            alternative: "",
                            placeholder: "Enter text string to search ",
                          },
                          model: {
                            value: _vm.form.q,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "q", $$v)
                            },
                            expression: "form.q",
                          },
                        }),
                        this.$route.name == "projects"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "base-checkbox",
                                  {
                                    staticClass: "mb-3",
                                    model: {
                                      value: _vm.form.archiveProjectTitle,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "archiveProjectTitle",
                                          $$v
                                        )
                                      },
                                      expression: "form.archiveProjectTitle",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Include Archived Projects\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c(
                                  "base-checkbox",
                                  {
                                    staticClass: "mb-3",
                                    model: {
                                      value: _vm.form.searchTaskTitle,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "searchTaskTitle",
                                          $$v
                                        )
                                      },
                                      expression: "form.searchTaskTitle",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Task Titles\n              "
                                    ),
                                  ]
                                ),
                                _c(
                                  "base-checkbox",
                                  {
                                    staticClass: "mb-3",
                                    model: {
                                      value: _vm.form.searchTaskText,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "searchTaskText",
                                          $$v
                                        )
                                      },
                                      expression: "form.searchTaskText",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Task Text\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-footer d-flex align-items-center justify-content-between",
                    },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "w-100",
                          attrs: { type: "secondary" },
                          on: { click: _vm._onResetClicked },
                        },
                        [_vm._v("Reset")]
                      ),
                      _c(
                        "base-button",
                        {
                          staticClass: "w-100",
                          attrs: { type: "primary" },
                          on: { click: _vm._onSearchViaModalClicked },
                        },
                        [_vm._v("Search")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c("detail-log", {
            attrs: { show: _vm.showLog, fullWidth: false },
            on: {
              outSideClicked: function ($event) {
                _vm.showLog = false
              },
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "navbar-brand mx-0" }, [
        _c(
          "a",
          {
            staticClass: "navbar-brand mr-0 nav-title",
            on: { click: _vm.onLogoClicked },
          },
          [
            _c("span", { staticClass: "app-name" }, [
              _vm.isMobile
                ? _c("span", [_vm._v("}")])
                : _c("span", [_vm._v("B {")]),
            ]),
            _c("span", [
              _vm.isMobile
                ? _c("span", { staticClass: "current-title-mobile" }, [
                    _vm._v("Projects"),
                  ])
                : _c("span", { staticClass: "current-title test" }, [
                    _vm._v(_vm._s(_vm.breadcrumb)),
                  ]),
            ]),
          ]
        ),
      ]),
      _c("div", { staticClass: "nav-menu" }, [
        _c("div", { staticClass: "ml-auto" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c(
              "div",
              {
                staticClass:
                  "navbar-search navbar-search-light form-inline mr-lg-5",
                class: { hidden: !_vm.showSearch },
                attrs: { id: "navbar-search-main" },
              },
              [
                _c("div", { staticClass: "form-group mb-0" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "input-group input-group-alternative input-group-merge",
                    },
                    [
                      _c("div", { staticClass: "el-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchQuery,
                              expression: "searchQuery",
                            },
                          ],
                          staticClass:
                            "el-input__inner select-danger w-100 border-0",
                          attrs: { type: "text", placeholder: "Search" },
                          domProps: { value: _vm.searchQuery },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.onSearchClicked.apply(null, arguments)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.searchQuery = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-action": "search-close",
                      "data-target": "#navbar-search-main",
                      "aria-label": "Close",
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
              ]
            ),
            _c("ul", { staticClass: "navbar-nav align-items-center" }, [
              _vm.profile && _vm.profile.role.name != "guest"
                ? _c("li", { staticClass: "nav-item mr-1 d-none" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link py-1 px-2",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            _vm.$router
                              .push({ name: "billing.home" })
                              .catch((e) => {})
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "btn-inner--icon text-lg text-sm" },
                          [
                            _c("i", {
                              staticClass: "fas fa-file-invoice-dollar",
                            }),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.profile && _vm.profile.role.name != "guest" && false
                ? _c("li", { staticClass: "nav-item mr-1" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link py-1 px-2",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            _vm.$router
                              .push({ name: "billing.log" })
                              .catch((e) => {})
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "btn-inner--icon text-lg text-sm" },
                          [_c("i", { staticClass: "fas fa-history" })]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.currentRoute == "tasks.home" || _vm.currentRoute == "projects"
                ? _c("li", { staticClass: "nav-item mr-5" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "input-group input-group--search rounded-0",
                      },
                      [
                        _c("div", { staticClass: "input-group-prepend mr-0" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "input-group-text input-group-text--search-box border-0 justify-content-center pr-2",
                              attrs: { id: "basic-addon1" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "icn-svg icn-searchbar" },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icn-svg-full",
                                      staticStyle: {
                                        "enable-background": "new 0 0 13 13",
                                      },
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 13 13",
                                        "xml:space": "preserve",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticStyle: {
                                          "fill-opacity": "1",
                                          fill: "#18234d",
                                        },
                                        attrs: {
                                          d: "M12.7 11.3 10 8.6c.6-.9 1-2 1-3.1C11 2.5 8.5 0 5.5 0S0 2.5 0 5.5 2.5 11 5.5 11c1.1 0 2.2-.3 3.1-1l2.7 2.7c.2.2.4.3.7.3.5 0 1-.5 1-1 0-.3-.1-.5-.3-.7zM5.5 9C3.6 9 2 7.4 2 5.5S3.6 2 5.5 2 9 3.6 9 5.5 7.4 9 5.5 9z",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchQuery,
                              expression: "searchQuery",
                            },
                          ],
                          staticClass:
                            "form-control form-control--search-box border-0 pl-0",
                          attrs: {
                            type: "text",
                            placeholder: "Search",
                            "aria-label": "Username",
                            "aria-describedby": "basic-addon1",
                          },
                          domProps: { value: _vm.searchQuery },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.onSearchClicked.apply(null, arguments)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.searchQuery = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.currentRoute == "projects"
                ? _c("li", { staticClass: "nav-item mr-1 d-none" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link py-1 px-2",
                        attrs: { href: "#" },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "btn-inner--icon text-lg text-md" },
                          [_c("i", { staticClass: "fas fa-expand-arrows-alt" })]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.currentRoute == "timesheet.home" && false
                ? _c(
                    "li",
                    {
                      staticClass:
                        "nav-item dropdown ml-0 ml-md-1 datepicker flatpickr-inpu",
                    },
                    [
                      _c("flat-picker", {
                        staticClass: "form-control datepicker",
                        attrs: { config: { wrap: true, allowInput: false } },
                        on: {
                          "on-open": () => {},
                          "on-close": () => {},
                          "on-change": () => {},
                        },
                        model: {
                          value: _vm.selectedDate,
                          callback: function ($$v) {
                            _vm.selectedDate = $$v
                          },
                          expression: "selectedDate",
                        },
                      }),
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-link icon-shape icon-shape--26 icon-shape--white py-1 px-2 timesheet-icon",
                          attrs: {
                            "data-toggle": "",
                            "data-original-title": "Timesheet Entry",
                            "data-target": "offcanvasTimer",
                            "data-offcanvasfrom": "offcanvas",
                          },
                          on: { click: _vm._onCalendarClicked },
                        },
                        [
                          _c("i", {
                            staticClass: "ni ni-calendar-grid-58",
                            staticStyle: { "font-size": "20px" },
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.profile && _vm.profile.role.name != "guest"
                ? _c("li", { staticClass: "nav-item mr-3" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "nav-link p-0 lh-1 d-flex align-items-center",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-original-title": "View detailed log",
                          "data-target": "offcanvasLog",
                          "data-offcanvasfrom": "offcanvas",
                        },
                        on: { click: _vm._onTimesheetClicked },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "btn-inner--icon icn-watch-nav text-lg text-sm",
                          },
                          [
                            _c("img", {
                              staticClass: "svg-full",
                              attrs: {
                                src: require("@/assets/img/icons/common/clock.svg"),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.profile && _vm.profile.role.name == "guest"
                ? _c(
                    "li",
                    {
                      staticClass:
                        "nav-item dropdown ml-2 ml-md-3 tf__box-sizer",
                    },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: { type: "success btn-sm px-3" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("headerLoginClicked")
                            },
                          },
                        },
                        [_vm._v("\n              Sign In\n            ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.profile && _vm.profile.role.name != "guest"
                ? _c("li", { staticClass: "nav-item mr-3 login" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center lh-1" },
                      [
                        _c("user-avatar", {
                          attrs: {
                            data: { user: _vm.profile },
                            disableEdit: true,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("userClicked")
                            },
                          },
                        }),
                        _c("span", { staticClass: "d-inline-block ml-2" }, [
                          _vm._v(
                            _vm._s(
                              _vm.profile.first_name +
                                " " +
                                _vm.profile.last_name
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.currentRoute == "tasks.home" ||
              _vm.currentRoute == "timeline.home"
                ? _c("li", { staticClass: "nav-item mr-2 ml-5" }, [
                    _vm.profile && _vm.profile.role.name != "guest"
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "nav-link p-0 d-flex h-100 align-items-center",
                            staticStyle: { cursor: "pointer" },
                            attrs: {
                              "data-action": "search-show",
                              title: "Timeline",
                              "data-target": "#navbar-search-main",
                            },
                            on: { click: _vm._onTimelineClicked },
                          },
                          [
                            _c("span", { staticClass: "icn-svg icn-clock" }, [
                              _c(
                                "svg",
                                {
                                  staticClass: "icn-svg-full",
                                  staticStyle: {
                                    "enable-background": "new 0 0 31.1 31.1",
                                  },
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    x: "0",
                                    y: "0",
                                    viewBox: "0 0 31.1 31.1",
                                    "xml:space": "preserve",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      fill: "#fadb36",
                                      d: "M15.5 2.4c7.2 0 13.1 5.9 13.1 13.1s-5.9 13.1-13.1 13.1S2.4 22.8 2.4 15.5 8.3 2.4 15.5 2.4m0-2.4C7 0 0 7 0 15.5S7 31 15.5 31 31 24 31 15.5 24.1 0 15.5 0z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      fill: "#fadb36",
                                      d: "M22 23.3c-.3 0-.6-.1-.8-.3l-6.7-7V8.6c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1v6.5l6.1 6.3c.4.4.4 1.1 0 1.6-.3.2-.5.3-.8.3z",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.currentRoute == "tasks.home" ||
              _vm.currentRoute == "tasks.quote"
                ? _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "nav-link px-2 py-0 d-flex align-items-center",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm._onQuoteViewClicked },
                      },
                      [
                        _c("span", { staticClass: "icn-svg icn-chartbar" }, [
                          _c(
                            "svg",
                            {
                              staticClass: "icn-svg-full",
                              staticStyle: {
                                "enable-background": "new 0 0 28.8 23.7",
                              },
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 28.8 23.7",
                                "xml:space": "preserve",
                              },
                            },
                            [
                              _c("path", {
                                staticStyle: {
                                  fill: "#fff",
                                  filter: "url(#Adobe_OpacityMaskFilter)",
                                },
                                attrs: {
                                  d: "M94 2.5C91.3-.4 87.8-2 84-2c-7.7 0-14 6.8-14 15.3 0 4.1 1.5 7.9 4.1 10.8 2.7 2.9 6.2 4.5 9.9 4.5 7.8 0 14.1-6.9 14.1-15.3 0-4.1-1.5-7.9-4.1-10.8zm-10 24c-3.2 0-6.3-1.4-8.6-3.9s-3.6-5.8-3.6-9.3C71.9 6 77.3.1 84 .1c3.2 0 6.3 1.4 8.6 3.9s3.6 5.8 3.6 9.3c0 7.3-5.5 13.2-12.2 13.2z",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  fill: "#fadb36",
                                  d: "M7.4 8.7h16.2c1.7 0 3 1.2 3 2.6v1.1c0 1.4-1.3 2.6-3 2.6H7.4c-1.7 0-3-1.2-3-2.6v-1.1c0-1.4 1.4-2.6 3-2.6zm6.7 8.8h11.7c1.7 0 3 1.2 3 2.6v1.1c0 1.4-1.3 2.6-3 2.6H14.1c-1.7 0-3-1.2-3-2.6v-1.1c0-1.5 1.3-2.6 3-2.6zM3 0h5.1c1.7 0 3 1.2 3 2.6v1.1c0 1.4-1.3 2.6-3 2.6H3c-1.7 0-3-1.2-3-2.6V2.6C0 1.2 1.3 0 3 0z",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }